module.exports = require("@collectivehealth/ch-user-agent");